import React, {Component} from 'react';
import {Form, Input,Select,Modal, Button,message} from 'antd';	
import { connect } from 'react-redux';


import {assignBeyondCheckUserAPI} from '@/API'
import {formItemLayout} from '@/constData'

const FormItem = Form.Item;
const Option = Select.Option;



class AssignBeyondCheckUserModal extends Component{
	state={
		btnLoading:false,
	}
	componentDidMount(){
	}

	handleSubmit = (e) => {
		let {taskId}=this.props
	    e.preventDefault();
	    this.props.form.validateFieldsAndScroll((err, values) => {
	      if (!err) {
			let postForm=values
			postForm.task_id=taskId
	        this.setState({btnLoading:true})
	      	assignBeyondCheckUserAPI(postForm).then(res=>{
	      	 	message.success('成功！');
	      	 	this.setState({btnLoading:false})
	      	 	this.props.handleClose('update')
	      	 	this.props.form.resetFields();
	      	 }).catch(e=>{
	      	 	this.setState({btnLoading:false})
	      	 })
	      }
	    });
	 }
	

	renderForm(){
		
		const ruleOption={
			input:{rules: [{ required: true, message: '必填项!', whitespace: true }]},

		}

		const { getFieldDecorator } = this.props.form;
		let {checkUserList}=this.props
		let assignOptions=checkUserList.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>)
	

	   return(
	    		<Form >
				<FormItem  {...formItemLayout} label="审查人" hasFeedback>
		          {getFieldDecorator('check_user', ruleOption.input)(
		          	<Select
	       				showSearch
				        defaultActiveFirstOption={false}
				        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
				      >
	       				{assignOptions}
	       			 </Select>
		          )}
		        </FormItem>
			</Form>
	    )
		
	}
	
	render(){
		let {btnLoading}=this.state
		let {openAssign,handleClose}=this.props
		
		return(
			<Modal
	          title='分配审查人'
	          visible={openAssign}
	          onCancel={handleClose}
	          footer={[
	            <Button key="cancel"  onClick={handleClose}>取消</Button>,
	            <Button key="save" type="primary"  loading={btnLoading} onClick={this.handleSubmit}>保存</Button>,
	          ]}
	        >
				{this.renderForm()}
			 </Modal>
		)
	}
}


export const WrappedAssignBeyondCheckUserForm = Form.create()(AssignBeyondCheckUserModal)



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/modal/assign_check_user.js